import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { toast } from "sonner";
import { Plus, Trash2 } from "lucide-react";

const empty = { question: "", answer: "", order: 0, active: true };

export default function AdminFAQ() {
  const [faqs, setFaqs] = useState([]);
  const [form, setForm] = useState(empty);
  const [editingId, setEditingId] = useState(null);

  const load = () => api.get("/admin/faqs").then((r) => setFaqs(r.data));
  useEffect(() => { load(); }, []);

  const save = async (e) => {
    e.preventDefault();
    if (editingId) await api.put(`/admin/faqs/${editingId}`, form);
    else await api.post("/admin/faqs", form);
    toast.success("Salvato");
    setForm(empty); setEditingId(null); load();
  };

  return (
    <div data-testid="admin-faq" className="p-10 max-w-5xl">
      <h1 className="font-serif text-4xl text-white mb-2">FAQ</h1>
      <p className="text-white/50 text-sm mb-10">Gestisci le domande frequenti.</p>

      <form onSubmit={save} className="luxe-card p-6 mb-8 space-y-4">
        <h3 className="font-serif text-xl text-white">{editingId ? "Modifica" : "Nuova FAQ"}</h3>
        <input required placeholder="Domanda" value={form.question} onChange={(e) => setForm({ ...form, question: e.target.value })} className="w-full bg-transparent border border-white/15 px-4 py-2.5 text-white focus:border-[var(--gold)] outline-none" />
        <textarea required placeholder="Risposta" rows={4} value={form.answer} onChange={(e) => setForm({ ...form, answer: e.target.value })} className="w-full bg-transparent border border-white/15 px-4 py-2.5 text-white focus:border-[var(--gold)] outline-none" />
        <div className="flex gap-4 items-center">
          <input type="number" placeholder="Ordine" value={form.order} onChange={(e) => setForm({ ...form, order: parseInt(e.target.value) || 0 })} className="w-32 bg-transparent border border-white/15 px-4 py-2.5 text-white focus:border-[var(--gold)] outline-none" />
          <label className="flex items-center gap-2 text-sm text-white/70"><input type="checkbox" checked={form.active} onChange={(e) => setForm({ ...form, active: e.target.checked })} /> Attiva</label>
        </div>
        <div className="flex gap-3">
          <button type="submit" className="btn-gold"><Plus size={14} /> {editingId ? "Aggiorna" : "Crea"}</button>
          {editingId && <button type="button" onClick={() => { setForm(empty); setEditingId(null); }} className="btn-ghost-gold">Annulla</button>}
        </div>
      </form>

      <div className="space-y-3">
        {faqs.map((f) => (
          <div key={f.id} className="luxe-card p-5">
            <div className="flex justify-between items-start gap-4">
              <div className="flex-1">
                <div className="font-serif text-lg text-white mb-1">{f.question}</div>
                <p className="text-sm text-white/60">{f.answer}</p>
              </div>
              <div className="flex gap-2 shrink-0">
                <button onClick={() => { setForm(f); setEditingId(f.id); }} className="text-xs px-3 py-1.5 border border-white/15 text-white/70 hover:border-[var(--gold)]">Modifica</button>
                <button onClick={async () => { if (confirm("Eliminare?")) { await api.delete(`/admin/faqs/${f.id}`); load(); } }} className="text-xs px-3 py-1.5 border border-red-500/30 text-red-400"><Trash2 size={12} /></button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
